var render = function render(){var _vm=this,_c=_vm._self._c;return _c('WarehouseForm',{attrs:{"warehouse":_vm.warehouse,"buttonLoading":_vm.buttonLoading},on:{"saveWarehouse":_vm.updateWarehouse}})
}
var staticRenderFns = []

export { render, staticRenderFns }